import React, { useState } from 'react';
import styled from 'styled-components';
import { Modal, DatePicker, Input } from 'antd';
import * as styles from './data-from-modal.scss';
import { BasicButton } from '../../../../assets/common';
import { arrow_down_filter_2, calendar_empty } from '../../../../assets/img';
import { DATE_TIME_FORMAT } from '../../../../utils/constants';
import { cloneDeep, isArray, isEmpty } from 'lodash';
const { RangePicker } = DatePicker;

export const DATA_FROM_TYPE = {
  THIS_MONTH: 'This Month',
  CUSTOM_MONTH: 'Custom Month',
  THIS_YEAR: 'This Year',
  CUSTOM_YEAR: 'Custom Year',
  CUSTOM_DATE_RANGE: 'Custom Date Range',
};

export const DATE_FILTER_TYPE = {
  MONTH: 'month',
  YEAR: 'year',
  DATE_RANGE: 'range',
};

const INIT_DATA_FROM = {
  type: DATA_FROM_TYPE.THIS_MONTH,
  month: DATA_FROM_TYPE.THIS_MONTH,
  year: undefined,
  range: [],
};

const DataFromModal = (props) => {
  const { showModal, setShowModal, setDataFrom, dataFrom, setUpdatedFilters } = props;
  const [inputFieldName, setInputFieldName] = useState(null);
  const [currentDataFrom, setCurrentDataFrom] = useState(INIT_DATA_FROM);

  const handleClose = () => {
    setShowModal(false);
  };

  const handleSetDataFrom = (type, value) => {
    setCurrentDataFrom({
      type,
      month: [DATA_FROM_TYPE.CUSTOM_MONTH].includes(type) ? value : null,
      year: [DATA_FROM_TYPE.CUSTOM_YEAR].includes(type) ? value : null,
      range: [DATA_FROM_TYPE.CUSTOM_DATE_RANGE].includes(type) ? value : [],
    });
  };

  const handleSelectRangePicker = (dateStrings) => {
    handleSetDataFrom(DATA_FROM_TYPE.CUSTOM_DATE_RANGE, dateStrings);
  };

  const handleChange = (e, type) => {
    const { value: inputValue } = e.target;
    const reg = /^[1-9]\d*$/;
    if (reg.test(inputValue) || inputValue === '' || inputValue === '-') {
      setCurrentDataFrom((prev) => ({
        ...prev,
        type,
        month: [DATA_FROM_TYPE.CUSTOM_MONTH].includes(type) ? inputValue : prev?.month,
        year: [DATA_FROM_TYPE.CUSTOM_YEAR].includes(type) ? inputValue : prev?.year,
      }));
    }
  };

  const handleBlur = (type) => {
    let cloneVal = [DATA_FROM_TYPE.CUSTOM_MONTH].includes(type) ? cloneDeep(currentDataFrom?.month) : cloneDeep(currentDataFrom?.year);
    if (isEmpty(cloneVal)) {
      setInputFieldName(null);
      return;
    }

    let valueTemp = cloneVal;
    if (cloneVal.charAt(cloneVal.length - 1) === '.' || cloneVal === '-') {
      valueTemp = cloneVal.slice(0, -1);
    }
    const convertVal = valueTemp.replace(/0*(\d+)/, '$1');
    setCurrentDataFrom((prev) => ({
      ...prev,
      type,
      month: [DATA_FROM_TYPE.CUSTOM_MONTH].includes(type) ? convertVal : prev?.month,
      year: [DATA_FROM_TYPE.CUSTOM_YEAR].includes(type) ? convertVal : prev?.year,
    }));
    setInputFieldName(null);
  };

  const handleApply = () => {
    let tempData = cloneDeep(currentDataFrom);
    switch (tempData?.type) {
      case DATA_FROM_TYPE.THIS_MONTH:
      case DATA_FROM_TYPE.CUSTOM_MONTH:
        tempData = {
          ...tempData,
          year: undefined,
          range: [],
        };
        break;
      case DATA_FROM_TYPE.THIS_YEAR:
      case DATA_FROM_TYPE.CUSTOM_YEAR:
        tempData = {
          ...tempData,
          month: undefined,
          range: [],
        };
        break;
      case DATA_FROM_TYPE.CUSTOM_DATE_RANGE:
        tempData = {
          ...tempData,
          month: undefined,
          year: undefined,
        };
        break;
      default:
        break;
    }
    setCurrentDataFrom(tempData);
    setDataFrom(tempData);
    setShowModal(false);
    setUpdatedFilters((prev) => {
      const cloneState = cloneDeep(prev);
      cloneState[3] = true;
      return cloneState;
    });
  };

  const handleClear = () => {
    setCurrentDataFrom(dataFrom);
  };

  return (
    <div>
      <CustomModal open={showModal} width={1250} footer={null} onCancel={handleClose}>
        <div className={styles.modalContainer}>
          <CustomModalHeader>
            <div className={`mainTitle`}>Show Data From</div>
          </CustomModalHeader>
          <CustomModalContent>
            <div className={'sectionWrap'}>
              <div className={'sectionItem'}>
                <div className={'sectionTitle'}>Monthly</div>
                <div className={'sectionContent'}>
                  <CustomBtn
                    onClick={() => handleSetDataFrom(DATA_FROM_TYPE.THIS_MONTH, 'This Month')}
                    className={[DATA_FROM_TYPE.THIS_MONTH].includes(currentDataFrom?.type) && 'active'}
                  >
                    This Month
                  </CustomBtn>
                  <span className={'orLabel'}>Or</span>
                  {(!inputFieldName || inputFieldName !== DATA_FROM_TYPE.CUSTOM_MONTH) && (
                    <CustomBtn
                      className={[DATA_FROM_TYPE.CUSTOM_MONTH].includes(currentDataFrom?.type) && 'active'}
                      onClick={() => {
                        setInputFieldName(DATA_FROM_TYPE.CUSTOM_MONTH);
                      }}
                    >
                      {currentDataFrom?.month && !isNaN(currentDataFrom?.month) ? `Last ${currentDataFrom?.month} Months` : `Custom Month`}
                    </CustomBtn>
                  )}
                  {inputFieldName && inputFieldName === DATA_FROM_TYPE.CUSTOM_MONTH && (
                    <CustomInput
                      className={[DATA_FROM_TYPE.CUSTOM_MONTH].includes(currentDataFrom?.type) && 'active'}
                      onChange={(e) => handleChange(e, DATA_FROM_TYPE.CUSTOM_MONTH)}
                      onBlur={() => handleBlur(DATA_FROM_TYPE.CUSTOM_MONTH)}
                      value={!isNaN(currentDataFrom?.month) ? currentDataFrom?.month : null}
                      placeholder="Enter Month, example: 2,3,7.."
                    ></CustomInput>
                  )}
                </div>
              </div>
              <div className={'sectionItem'}>
                <div className={'sectionTitle'}>Yearly</div>
                <div className={'sectionContent'}>
                  <CustomBtn
                    className={[DATA_FROM_TYPE.THIS_YEAR].includes(currentDataFrom?.type) && 'active'}
                    onClick={() => handleSetDataFrom(DATA_FROM_TYPE.THIS_YEAR, 'This Year')}
                  >
                    This Year
                  </CustomBtn>
                  <span className={'orLabel'}>Or</span>
                  {(!inputFieldName || inputFieldName !== DATA_FROM_TYPE.CUSTOM_YEAR) && (
                    <CustomBtn
                      className={[DATA_FROM_TYPE.CUSTOM_YEAR].includes(currentDataFrom?.type) && 'active'}
                      onClick={() => {
                        setInputFieldName(DATA_FROM_TYPE.CUSTOM_YEAR);
                      }}
                    >
                      {currentDataFrom?.year && !isNaN(currentDataFrom?.year) ? `Last ${currentDataFrom?.year} Years` : `Custom Year`}
                    </CustomBtn>
                  )}
                  {inputFieldName && inputFieldName === DATA_FROM_TYPE.CUSTOM_YEAR && (
                    <CustomInput
                      className={[DATA_FROM_TYPE.CUSTOM_YEAR].includes(currentDataFrom?.type) && 'active'}
                      onChange={(e) => handleChange(e, DATA_FROM_TYPE.CUSTOM_YEAR)}
                      onBlur={() => handleBlur(DATA_FROM_TYPE.CUSTOM_YEAR)}
                      value={!isNaN(currentDataFrom?.year) ? currentDataFrom?.year : null}
                      placeholder="Enter Year, example: 2,3,7.."
                    ></CustomInput>
                  )}
                </div>
              </div>
              <div className={'sectionItem'}>
                <div className={'sectionTitle'}>By Date Range</div>
                <div className={'sectionContent'}>
                  <CustomBtn className={`fullWidth ${[DATA_FROM_TYPE.CUSTOM_DATE_RANGE].includes(currentDataFrom?.type) && 'active'}`}>
                    <img width={16} height={16} src={calendar_empty} alt="" />
                    <span className={'label'}>
                      {isArray(currentDataFrom?.range) && !isEmpty(currentDataFrom?.range)
                        ? `${currentDataFrom?.range[0]} - ${currentDataFrom?.range[1]}`
                        : `Custom Date Range`}
                    </span>
                    <img src={arrow_down_filter_2} alt="" />
                  </CustomBtn>
                  <CustomRangePicker
                    dropdownClassName={'dataFromRangePicker'}
                    onChange={(_, dateStrings) => handleSelectRangePicker(dateStrings)}
                    format={DATE_TIME_FORMAT.DATE_SLASH}
                    allowClear
                  />
                </div>
              </div>
            </div>
          </CustomModalContent>
          <CustomModalFooter>
            <BasicButton height={36} onClick={handleClear}>
              Clear
            </BasicButton>
            <BasicButton height={36} mode="teal" onClick={handleApply}>
              Apply
            </BasicButton>
          </CustomModalFooter>
        </div>
      </CustomModal>
    </div>
  );
};

export default DataFromModal;

const CustomModal = styled(Modal)`
  width: 532px !important;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const CustomModalHeader = styled.div`
  position: relative;
  margin-bottom: 30px;

  .mainTitle {
    font-family: Inter;
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
    vertical-align: middle;
    color: #262d36;
  }
`;

const CustomModalContent = styled.div`
  position: relative;

  .sectionItem {
    margin-bottom: 30px;
  }

  .sectionTitle {
    font-family: Inter;
    font-weight: 600;
    font-size: 12px;
    line-height: 12.5px;
    letter-spacing: 0%;
    vertical-align: middle;
    color: #5d7083;
    margin-bottom: 10px;
  }

  .sectionContent {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .orLabel {
    font-family: Inter;
    font-weight: 600;
    font-size: 12px;
    line-height: 12.5px;
    letter-spacing: 0%;
    vertical-align: middle;
    color: #7a7a7a;
  }
`;

const CustomModalFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 15px;

  & > button {
    width: 50%;
  }
`;

const CustomBtn = styled.div`
  font-family: Inter;
  font-weight: 600;
  font-size: 12px;
  line-height: 12.5px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #15191e;
  border: solid 1px #cbd6e2;
  border-radius: 2px;
  padding: 12px 8px;
  min-width: 214px;
  text-align: center;
  cursor: pointer;

  &.fullWidth {
    min-width: 100%;
  }

  &.active {
    background-color: #f4fbfb;
    border-color: #00807c;
  }

  .label {
    padding: 0 10px;
  }

  [contenteditable]:empty:before {
    content: attr(data-placeholder);
    color: #15191e;
    text-align: left;
    pointer-events: none;
    display: block;
  }
`;

const CustomRangePicker = styled(RangePicker)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 42px;
  opacity: 0;
  cursor: pointer;
`;

const CustomInput = styled(Input)`
  font-family: Inter;
  font-weight: 600;
  font-size: 12px;
  line-height: 12.5px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #15191e;
  border: solid 1px #cbd6e2;
  border-radius: 2px;
  padding: 12px 8px;
  width: 214px;
  box-shadow: none;
  text-align: center;

  &:focus,
  &:hover,
  &:active {
    box-shadow: none !important;
  }

  &.active {
    border-color: #00807c;
  }

  &::placeholder {
    font-family: Inter;
    font-weight: 400;
    font-size: 12px;
    line-height: 12.5px;
    letter-spacing: 0%;
    text-align: left;
    vertical-align: middle;
  }
`;
